export default __webpack_public_path__ + "static/media/480_dummy2016-kuenstler02-mobile-de.c92412a4.png";